
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiZwStoreDetail, apiZwStoreAdd, apiZwStoreEdit } from '@/api/shop'
import { throttle } from '@/utils/util'
import config from '@/config'
@Component
export default class ZwStoreEdit extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  // 添加表单数据
  form: any = {
    customer_name: '', 
    customer_code: '',
    store_name: '',
    store_code: '',
    remark: ''
  };

  // 表单校验
  rules = {
    customer_code: [{ required: true, message: '请输入账号编码', trigger: 'blur' }],
    store_name: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
    store_code: [{ required: true, message: '请输入店铺编码', trigger: 'blur' }]
  };

  /** E Data **/
  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return

      if (!this.identity) {
        this.handleZwStoreAdd()
      } else {
        this.handleZwStoreEdit()
      }
    })
  }

  // 获取详情
  async getZwStoreDetail(): Promise<void> {
    const res: any = await apiZwStoreDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      if (res[key] === null || res[key] === undefined) return
      this.$set(this.form, key, res[key])
    })
    console.log(this.form)
  }

  // 添加店铺
  async handleZwStoreAdd(): Promise<void> {
    await apiZwStoreAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑店铺
  async handleZwStoreEdit(): Promise<void> {
    await apiZwStoreEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }
  /** E Methods **/

  /** S Life Cycle **/
  async created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      await this.getZwStoreDetail()
    }
    this.onSubmit = throttle(this.onSubmit, 1000)
  }
  /** E Life Cycle **/
}
